import {
  COLISEUM_510K_BODY_CAPACITY,
  COLISEUM_510K_CONTACT_ROW_CAPACITY,
} from './contactSoaLayout';

/** Shared capacity constants for the production-independent exact-wide path. */
export const COLISEUM_510K_CANDIDATE_PAIR_CAPACITY = 8_160_000;
export const COLISEUM_510K_PERSISTENT_MANIFOLD_CAPACITY = 2_097_152;
export const COLISEUM_510K_PERSISTENT_HASH_CAPACITY = 4_194_304;
export const COLISEUM_510K_PAIR_MANIFOLD_SLOTS = 8;

export const COLISEUM_510K_WIDE_EXACT_STORAGE_PROFILE = Object.freeze({
  maxBodies: COLISEUM_510K_BODY_CAPACITY,
  candidatePairCapacity: COLISEUM_510K_CANDIDATE_PAIR_CAPACITY,
  contactRowCapacity: COLISEUM_510K_CONTACT_ROW_CAPACITY,
  persistentManifoldCapacity: COLISEUM_510K_PERSISTENT_MANIFOLD_CAPACITY,
  persistentHashCapacity: COLISEUM_510K_PERSISTENT_HASH_CAPACITY,
  pairManifoldSlots: COLISEUM_510K_PAIR_MANIFOLD_SLOTS,
});
